import posthog from 'posthog-js'

// PERFORMANCE FIX: Disable session recording (uses rrweb which kills main thread)
// Enable manually with localStorage.setItem('ul_session_recording', '1')
const ENABLE_SESSION_RECORDING = localStorage.getItem('ul_session_recording') === '1';

export function initAnalytics(key){
  if (key) {
    posthog.init(key, { 
      api_host: 'https://app.posthog.com', 
      capture_pageview: true,
      // Disable session recording by default - massive performance win
      disable_session_recording: !ENABLE_SESSION_RECORDING,
      // Also disable these to reduce overhead
      autocapture: false,
    })
    
    if (!ENABLE_SESSION_RECORDING) {
      console.log('[Analytics] Session recording DISABLED for performance. Enable: localStorage.setItem("ul_session_recording", "1")');
    }
  }
}

export function track(event, props){ 
  if (posthog.__loaded) {
    posthog.capture(event, props)
  }
}
